export const getGeracaoOs = (state) => state["geracao-os"];
